<template>
    <div id="app" :style="background">
        <router-view />
    </div>
</template>

<script>
export default {
    data: () => ({}),
    computed: {
        background() {
            if (process.env.NODE_ENV === "development") {
                return {
                    backgroundColor: "#333",
                };
            }
        },
    },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Noto+Sans+TC:400,700,900");

html,
body {
    padding: 0;
    margin: 0;
    font-family: "Noto Sans TC", sans-serif;
}

#app {
    position: relative;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
}
</style>
